import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,Box,Button,Grid,Paper
} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { CloudUpload } from '@material-ui/icons';
import * as XLSX from "xlsx";
import { findAuctionLot  } from 'src/adminModel/auctions';

export default function UploadStep({ auctionList,setData, setSelectedAuction,selectedAuction }) {
    const [auction, setAuction] =React.useState("");
    const [file, setFile] = React.useState(null);
    const fileInputRef = React.useRef(null);
    const  [error, setError] = React.useState("")

    const handleBrowseClick = () => {
    if (fileInputRef.current) {
        fileInputRef.current.click();
    }
    };

const fetchData = async (id, lot) => {
    try {

        const response = await findAuctionLot(id, lot);

        return response;

    } catch (error) {

        console.error(error);

        throw error;

    }
};

const handleFile = (e) => {

    const file = e.target.files[0];
    if (!auction){
        alert("please select auction");
        return;
    }
    if (!file) return;

    setFile(file);

    const reader = new FileReader();

    reader.onload = async (event) => {
        
        try {

            const data = event.target.result;

            const workbook = XLSX.read(data, {
                type: "array",
            });

            const sheetName = workbook.SheetNames[0];

            const worksheet = workbook.Sheets[sheetName];

            const json = XLSX.utils.sheet_to_json(worksheet);

            const result = [];
            const invalidLots = [];

            for (const item of json) {

                let lotDetails;

                try {

                    lotDetails = await fetchData(
                        selectedAuction,
                        item["Lot Number"]
                    );
                             
                    if (lotDetails.sucess === false || lotDetails===false) {
                
                        invalidLots.push(item["Lot Number"]);

                        // itutuloy pa rin ang processing
                        lotDetails = null;
                        
                    }

                } catch (error) {
            
                    invalidLots.push(item["Lot Number"]);

                    lotDetails = null;
                }

                const existing = result.find(
                    x => x.customerGroup === item["Customer Group"]
                );

                if (existing) {

                    existing.lotNumber.push(item["Lot Number"]);

                    existing.hammerPrice += Number(item["Hammer Price"] || 0);

                    existing.items.push(lotDetails);

                } else {

                    result.push({

                        customerGroup: item["Customer Group"],
                        customerCode: item["Customer Code"],
                        customerName: item["Customer Name"],
                        email: item["Email"],
                        lotNumber: [item["Lot Number"]],
                        hammerPrice: Number(item["Hammer Price"] || 0),
                        items: [lotDetails]

                    });

                }

            }

            setData(result);
          
            if (invalidLots.length > 0) {

                setError(
                    `Invalid Lot Number(s): ${invalidLots.join(", ")}`
                );

            } else {

                setError("");

            }
        } catch (error) {

            console.error(error);

            alert("Invalid Excel file.");

        }

    };

    reader.onerror = () => {

        alert("Unable to read file.");

    };

    reader.readAsArrayBuffer(file);

};


const handleDownloadTemplate = () => {
  window.open(
    '/templates/Bulk_Invoice_Upload_Template.xlsx',
    '_blank'
  );
};
const handleSelectAuction = (value) =>{
 
    setSelectedAuction(value)
    setAuction(value)
}
    return(
        <div>
       <div style={{
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                padding: '20px',
                background: '#fafafa',
                marginBottom:"25px"
            }}>
             
                <Box>
                <Typography variant="h5" style={{ fontWeight: 'bold', color: '#000' }}>
                   1. Select Auction
                </Typography>
                <Typography variant="body2" style={{ color: '#555' ,marginTop:"5px"}}>
                   Choose the auction where the invoices will be uploaded
                </Typography>
                </Box>     
                    <FormControl
                        variant="outlined"
                
                        style={{
                            width: '500px',
                            marginTop: 20,
                            background: '#fff',
                        }}
                        >
                        <InputLabel>Select Template</InputLabel>
                        <Select
                            value={auction}
                            onChange={(e) => handleSelectAuction(e.target.value)}
                            label="Select Template"
                        >
                            <MenuItem value="">
                            <em>Select Auction</em>
                            </MenuItem>
                            {auctionList.data.map((auction, index) => (
                            
                                    <MenuItem key={index} value={auction.id}>{auction.auction_name}</MenuItem>

                            
                            ))}
                        
                            
                        </Select>

                </FormControl>
                    
        </div>
       <div
            style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '24px',
                background: '#fafafa',
            }}
            >
            {/* Header */}
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={3}
            >
                <Box>
                <Typography
                    variant="h6"
                    style={{
                    fontWeight: 600,
                    color: '#000',
                    }}
                >
                    2. Upload Excel File
                </Typography>

                <Typography
                    variant="body2"
                    style={{
                    color: '#666',
                    marginTop: 4,
                    }}
                >
                    Download the template, fill in your data, and upload the file.
                </Typography>
                </Box>

                <Button
                variant="outlined"
                startIcon={<GetAppIcon />}
                  onClick={handleDownloadTemplate}
                style={{
                    borderColor: '#217346',
                    color: '#217346',
                    textTransform: 'none',
                }}
                >
                Download Excel Template
                </Button>
            </Box>

            {/* Upload Area + Guide */}
            <Grid container spacing={3}>
                <Grid item xs={12} md={9}>
                <Paper
                
                    variant="outlined"
                     onClick={handleBrowseClick}
                    style={{
                    padding: '50px 20px',
                    textAlign: 'center',
                    border: '2px dashed #d0d0d0',
                    background: '#fff',
                    cursor: 'pointer',
                    boxShadow: 'none',
                    }}
                >
                    <CloudUpload
                    style={{
                        fontSize: 48,
                        color: '#999',
                    }}
                    />

                    <Typography
                    variant="subtitle1"
                    style={{
                        marginTop: 12,
                        fontWeight: 500,
                    }}
                    >
                    Drag and drop your Excel file here
                    </Typography>

                    <Typography
                    variant="body2"
                    color="textSecondary"
                    >
                    or click to browse
                    </Typography>

                   <input
                    ref={fileInputRef}
                    type="file"
                    accept=".xlsx,.xls"
                    hidden
                    onChange={handleFile}
                    />
                </Paper>

                <Typography
                    variant="body2"
                    style={{
                    marginTop: 10,
                    color: '#666',
                    }}
                >
                    Supported formats: .xlsx, .xls | Max file size: 10MB
                  
                </Typography>
                 {file && (
                    <>
                    <Typography
                    variant="body2"
                    style={{
                        marginTop: 10,
                        color: "#217346",
                    }}
                    >
                    Selected: {file.name}
                    </Typography>

                    {error && (
                    <Typography
                        variant="body2"
                        style={{
                        color: "#d32f2f",
                        marginTop: 5,
                        fontWeight: 500,
                        }}
                    >
                        {error}
                    </Typography>
                    )}
                </>
                )}
                </Grid>

                <Grid item xs={12} md={3}>
                <Paper
                    variant="outlined"
                    style={{
                    padding: 20,
                    background: '#fff',
                    height: '100%',
                    boxShadow: 'none',
                    }}
                >
                    <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 600 }}
                    >
                    Template Guide
                    </Typography>

                    <Typography
                    variant="body2"
                    style={{
                        marginTop: 10,
                        color: '#666',
                        lineHeight: 1.6,
                    }}
                    >
                    Your Excel file must follow the
                    correct column format.
                    </Typography>

                    <Button
                    style={{
                        marginTop: 16,
                        color: '#217346',
                        textTransform: 'none',
                        padding: 0,
                    }}
                    >
                    View required columns →
                    </Button>
                </Paper>
                </Grid>
            </Grid>

            {/* Notes */}
            <Paper
                variant="outlined"
                style={{
                marginTop: 20,
                padding: 20,
                background: '#f8f9ff',
                boxShadow: 'none',
                }}
            >
                <Typography
                variant="subtitle2"
                style={{
                    fontWeight: 600,
                    marginBottom: 10,
                }}
                >
                Important Notes
                </Typography>

                <ul style={{ margin: 0 }}>
                <li>
                    Please ensure the data in your Excel file is correct before uploading.
                </li>
                <li>
                    You will be able to preview and validate the data in the next step before importing.
                </li>
                </ul>
            </Paper>
            </div>           
        </div>
        
    )
  
};

 